
import {MaterialUiPickersDate} from "@material-ui/pickers/typings/date";
import {KeyboardDatePicker} from "@material-ui/pickers";
import React from "react";

export type ApplicationDatePickerProps = {
    name:string,
    value:any,
    onChange:(val:{target:{value:any}})=>void,
    disableFuture?:boolean
};

export const ApplicationDatePicker=(props:ApplicationDatePickerProps)=>{
    let {onChange} = props;
    const onDateChange = (evnt:MaterialUiPickersDate)=>{
        if (evnt){
            let val = evnt.format('yyyy-MM-DD')
            onChange({target:{value:val}});
        }else{
            onChange({target:{value:null}});
        }
    };
    const dateFormatter = (str:any) => {
        return str;
    };
    return <KeyboardDatePicker
        autoOk
        clearable
        disableFuture={props.disableFuture}
        variant="inline"
        format="DD/MM/yyyy"
        margin="normal"
        value={props.value}
        name={props.name}
        onChange={onDateChange}
        rifmFormatter={dateFormatter}
        KeyboardButtonProps={{
            'aria-label': 'change date',
        }}
    />
};